







































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { NewsModel } from "@/api/models/accesPlateformeBeneficiaires/news";

import {
  BButton,
  BCard,
  BCol,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BModal,
  BRow,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import RessifnetQuillEditor from "@/components/inputs/RessifnetQuillEditor.vue";
import TagInput from "@/components/inputs/TagInput.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";

@Component({
  name: "ptf-beneficiaire-create-news",
  components: {
    RessifnetQuillEditor,
    BCard,
    BRow,
    FeatherIcon,
    BCol,
    BFormInput,
    BFormFile,
    BFormTextarea,
    BButton,
    TagInput,
    BModal,
    ValidationObserver,
    ValidationProvider,
    SearchableVueSelect,
  },
})
export default class CreateNews extends Vue {
  @Prop({ default: false }) show: boolean = false;

  showModal: boolean = false;

  newsModel: NewsModel = {
    titre: "",
    contenu: "",
    resume: "",
    image: undefined,
    motCles: [],
    tags: [],
  };

  tagsList: string[] = [];

  @Watch("show")
  onShowChanged(newVal: boolean) {
    this.showModal = newVal;
    if (newVal) {
      this.resetModel();
    }
  }

  async created() {
    await this.loadListTags();
  }

  async loadListTags() {
    this.$http.myressif.parametres
      .getByNom("news_tags_list")
      .then((tags: any) => {
        this.tagsList = JSON.parse(tags?.valeur ?? "[]");
      })
      .catch(() => {
        errorAlert.fire({
          title: "Erreur de chargement",
          text: "Impossible de charger la liste des tags.",
        });
      });
  }

  saveNews() {
    this.$http.myressif.ptfBeneficiaireNews
      .createNews(this.newsModel)
      .then(() => {
        this.resetModel();
        successAlert.fire({
          title: "Article créé avec succès",
          text: "L'article a été ajouté à la liste.",
          icon: "success",
        });
        this.$emit("reload");
      })
      .catch((error: any) => {
        console.error("Error creating news:", error);
        errorAlert.fire({
          title: "Erreur lors de la création de l'article",
          text: "Veuillez vérifier les informations saisies.",
          icon: "error",
        });
      });
    this.closeModal();
  }

  closeModal() {
    this.showModal = false;
    this.$emit("close");
  }

  resetModel() {
    this.newsModel = {
      titre: "",
      contenu: "",
      resume: "",
      motCles: [],
      tags: [],
    };
  }
}
